/* eslint-disable max-statements */
/* eslint-disable max-lines-per-function */
import React, { useEffect, useState } from "react";
import { NavigateFn } from "@reach/router";
import MuiPagination from "@material-ui/lab/Pagination";
import { Button, Grid, TextField } from "@material-ui/core";
import { useSidebarFilters } from "../sidebar-filters";
import styles from "./pagination.module.css";
import { useInterestsTable } from "./table-context";
interface Props {
  interestListId: string;
  requestedPage: number;
  navigate: NavigateFn;
}

const GoToPageForm: React.FC<{
  goToPage: (pg: number) => void;
  nbPages: number
}> = ({ goToPage, nbPages }) => {
  const [jumpPage, setJumpPage] = useState("");
  const handleJumpPageChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    event.preventDefault();
    setJumpPage(event.target.value);
  };

  const handleJump: React.FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    goToPage(parseInt(jumpPage, 10));
  };

  return (<form onSubmit={handleJump}>
    <TextField
      label="Jump To Page"
      value={jumpPage}
      className={styles.jumpInput}
      onChange={handleJumpPageChange}
      variant="outlined"
      margin="none"
      size="small"
      type="number"
      inputProps={{ min: 1, max: nbPages }}
      style={{ fontWeight: 300 }}
    />
    <Button
      className={styles.jumpButton}
      type="submit"
      variant="contained"
      color="primary">Go</Button>
  </form>);
};

const Pagination: React.FC<Props> = (props) => {
  const { deselectAllInterests } = useInterestsTable();
  const {
    pageState,
    setSelectedPage,
  } = useSidebarFilters();

  if (typeof props.requestedPage === "undefined") {
    props.navigate("p/1");
  } else if (props.requestedPage <= 0 || (
    pageState.nbPages > 0 && props.requestedPage > pageState.nbPages)) {
    props.navigate("../1");
  }

  useEffect(() => {
    if (pageState.page !== props.requestedPage - 1) {
      setSelectedPage(props.requestedPage - 1);
    }
  }, []);

  const goToPage = (pg: number) => {
    deselectAllInterests();
    setSelectedPage(pg - 1);
    props.navigate(`../${pg}`);
  };


  const handleChange = (event:any, pg:any) => {
    event.target.blur();
    goToPage(pg);
  };

  // Wrapping in 8px margin to fix the Grid container negative margin breaking scroll
  return (
    <div style={{ margin: "8px" }}>
      <Grid container className={styles.container} justifyContent="center" alignContent="center" spacing={2}>
        {pageState.page === 2000 && "The search is too broad. Please refine your search. We're limiting results to 50000."}
        {pageState.nbPages === 0 ? "No Results" : (
          <>
            <Grid item>
              <div className={styles.paginationBorder}>
                <MuiPagination
                  count={pageState.nbPages}
                  page={pageState.page + 1}
                  onChange={handleChange}
                  showFirstButton
                  showLastButton
                  siblingCount={3}
                />
              </div>
            </Grid>
            <Grid item>
              <GoToPageForm nbPages={pageState.nbPages} goToPage={goToPage} />
            </Grid></>
        )}
      </Grid>
    </div>
  );
};

export default Pagination;
